import React, { ComponentProps } from 'react';
import {
  BlockInteractions,
  Views as BlockInteractionsViews,
  DISPLAY_TYPE,
  createButtonObject,
} from '../../components/organisms/BlockInteractions';
import { Namespace } from '../../translation/namespace';
import { Icons } from '../../components/atoms/SVG';
import { asFetchableBlock, useBlockContext, useRefreshBlock } from '../../_lib/BlockFetcher';
import { BlockType } from '../../types/api/ElementType';
import { DefaultView, EditView, Views } from '../../types/BlockWithViews';
import { useSonTranslation } from '../../translation/useSonTranslation';
import { useContentWrapperContext } from '../../components/blocks/ContentWrapper/ContentWrapperContext';
import { ChildPagesDefaultView } from './views/ChildPagesDefaultView';
import { ChildPagesEditView } from './views/ChildPagesEditView';
import { useContentWrapperDndContext } from '../../components/blocks/ContentWrapper/ContentWrapperDndProvider';
import { headlineHierarchy } from '../../components/organisms/BlockInteractions/BlockInteractions.utils';

type ChildPagesBlockProps = Views<DefaultView<ChildPagesDefaultView> & EditView<ChildPagesEditView>>;

function ChildPages({ views }: ChildPagesBlockProps) {
  const { t } = useSonTranslation('ChildPagesBlock');
  const { uuid, elementType } = useBlockContext();
  const { refresh, refreshCount } = useRefreshBlock();
  const contentWrapperContext = useContentWrapperContext();
  const contentWrapperDndContext = useContentWrapperDndContext();
  const blockInteractionButtons =
    views.edit &&
    createButtonObject(
      BlockInteractionsViews.EDIT,
      Icons.EDIT_PENCIL,
      `${Namespace.ChildPagesBlock}:actions.edit`,
      DISPLAY_TYPE.COLLAPSIBLE,
      <ChildPagesEditView {...views.edit} />
    );

  return (
    <BlockInteractions
      headline={{
        text: t('childPages'),
        hierarchy: headlineHierarchy(2, contentWrapperContext?.parentIndex, contentWrapperContext?.grandParentIndex),
        visible: true,
      }}
      views={views}
      uuid={uuid}
      buttons={blockInteractionButtons}
      refreshBlock={refresh}
      refreshCount={refreshCount}
      elementType={elementType}
      contentWrapperContext={contentWrapperContext}
      contentWrapperDndContext={contentWrapperDndContext}
    >
      <ChildPagesDefaultView {...views.default} />
    </BlockInteractions>
  );
}

export const ChildPagesBlock = asFetchableBlock(ChildPages, BlockType.childpages);
export type ChildPagesBlock = ComponentProps<typeof ChildPagesBlock>;
